import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StarField from "../components/StarField";
import { api, setSeo } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    setSeo(
      "Contact Us | Shillong Lucky Ending",
      "Get in touch with the Shillong Lucky Ending team. Send us your questions, feedback or suggestions about our Lucky Ending results."
    );
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setStatus("");
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus("err:Please fill in all fields.");
      return;
    }
    setSending(true);
    try {
      await api.post("/contact", form);
      setStatus("ok:Thank you! Your message has been sent successfully.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus("err:Something went wrong. Please try again later.");
    } finally {
      setSending(false);
    }
  };

  const [kind, text] = status.includes(":") ? status.split(/:(.+)/) : ["", ""];

  return (
    <div data-testid="contact-page">
      <StarField />
      <Header />
      <div className="page-header">
        <h1>Contact Us</h1>
      </div>

      <div className="admin-wrap" style={{ maxWidth: 560 }}>
        <div className="admin-card">
          <div className="admin-sub" style={{ marginBottom: 20 }}>
            Have a question, feedback or suggestion about <strong>Shillong Lucky Ending</strong>? Fill in the form
            below and our team will get back to you as soon as possible.
          </div>

          <form onSubmit={submit}>
            <label className="admin-label">Your Name</label>
            <input
              className="admin-input"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Enter your name"
              data-testid="contact-name"
              style={{ marginBottom: 16 }}
            />
            <label className="admin-label">Email Address</label>
            <input
              className="admin-input"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="you@example.com"
              data-testid="contact-email"
              style={{ marginBottom: 16 }}
            />
            <label className="admin-label">Message</label>
            <textarea
              className="admin-input"
              rows={5}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Type your message here…"
              data-testid="contact-message"
              style={{ marginBottom: 8, resize: "vertical", fontFamily: "inherit" }}
            />
            <button className="admin-btn" type="submit" disabled={sending} data-testid="contact-submit">
              {sending ? "Sending…" : "Send Message"}
            </button>
            {kind === "ok" && (
              <div style={{ color: "#0be881", fontSize: 14, marginTop: 12, textAlign: "center" }} data-testid="contact-success">
                {text}
              </div>
            )}
            {kind === "err" && (
              <div className="admin-err" data-testid="contact-error">{text}</div>
            )}
          </form>

          <div style={{ marginTop: 24, borderTop: "1px solid #2a2a35", paddingTop: 18, textAlign: "center" }}>
            <div style={{ color: "#8a8a99", fontSize: 13 }}>You can also reach us directly at</div>
            <a href="mailto:support@shillongluckyending.com" style={{ color: "#0be881", fontWeight: 600, textDecoration: "none" }} data-testid="contact-email-link">
              support@shillongluckyending.com
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
